(function ($) {
  DJ.addBehavior('mapReset', '.map-section-reset-map', {
    attach: function () {
      const fakeResetMapButton = this;

      // On click on the fake reset click on the real reset button.
      fakeResetMapButton.addEventListener('click', () => {
        const realResetButton = document.querySelector('.map-contacts__inner [name="reset"]');
        const searchInput = document.querySelector('.map-contacts__inner input[name="search_api_fulltext"]');
        const submitButton = document.querySelector('.map-contacts__inner input[type="submit"][data-drupal-selector*="edit-submit"]');

        // Clear the search input if it exists.
        if (searchInput) {
          searchInput.value = '';
          // Trigger change event to ensure Drupal recognizes the change
          const changeEvent = new Event('change', { bubbles: true });
          searchInput.dispatchEvent(changeEvent);
        }

        if (submitButton) {
          submitButton.click();
        } else if (realResetButton) {
          realResetButton.click();
        }
      });
    }
  });
})(jQuery);
